import { render, staticRenderFns } from "./matchmakerTeamIntro.vue?vue&type=template&id=54eb7326&scoped=true"
import script from "./matchmakerTeamIntro.vue?vue&type=script&lang=js"
export * from "./matchmakerTeamIntro.vue?vue&type=script&lang=js"
import style0 from "./matchmakerTeamIntro.vue?vue&type=style&index=0&id=54eb7326&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54eb7326",
  null
  
)

export default component.exports